import { createLogger } from "@effektify/logger";
const LOG_LEVEL = "info";
let loggerInstance = null;
const useLogger = (scope = "", options = {}) => {
  if (loggerInstance) {
    return loggerInstance;
  }
  loggerInstance = createLogger("Engine", scope, {
    level: LOG_LEVEL,
    ...options
  }).logger;
  return loggerInstance;
};
export {
  useLogger as default
};
